import RecoverPassword from './containers/RecoverPassword';
import React from 'react';

export {uiDataRecoverPassword} from './reducers/RecoverPassword';
export default RecoverPassword;